module.exports = __webpack_public_path__ + "img/Generaxion_OPN_Logo_Sort.f9040c96.svg";